/**
 * Mock data for Dashboard
 */

import { PendingAction, DashboardKPI } from '../../types/dashboard';
import { generateId } from './mockData';

// Generate mock pending actions
const generateMockPendingActions = (): PendingAction[] => {
  const now = new Date();
  const actions: PendingAction[] = [
    {
      id: generateId(),
      caseSummary: 'Review new evidence for Mission #734',
      priority: 'high',
      createdAt: new Date(now.getTime() - 2 * 60 * 60 * 1000),
      createdAtText: '2 hours ago',
      updatedAt: new Date(now.getTime() - 1 * 60 * 60 * 1000),
      updatedAtText: '1 hour ago',
      actionType: 'review',
      type: 'ContentModeration',
    },
    {
      id: generateId(),
      caseSummary: 'Approve new user: john.doe@example.com',
      priority: 'medium',
      createdAt: new Date(now.getTime() - 8 * 60 * 60 * 1000),
      createdAtText: '8 hours ago',
      updatedAt: new Date(now.getTime() - 8 * 60 * 60 * 1000),
      updatedAtText: '8 hours ago',
      actionType: 'approve',
      type: 'User',
    },
    {
      id: generateId(),
      caseSummary: 'AI Alert: Anomalous activity in Mission #512',
      priority: 'high',
      createdAt: new Date(now.getTime() - 24 * 60 * 60 * 1000),
      createdAtText: 'Yesterday',
      updatedAt: new Date(now.getTime() - 12 * 60 * 60 * 1000),
      updatedAtText: '12 hours ago',
      actionType: 'investigate',
      type: 'ContentModeration',
    },
    {
      id: generateId(),
      caseSummary: 'Review Ghost verification request for Sarah Johnson',
      priority: 'medium',
      createdAt: new Date(now.getTime() - 12 * 60 * 60 * 1000),
      createdAtText: '12 hours ago',
      updatedAt: new Date(now.getTime() - 12 * 60 * 60 * 1000),
      updatedAtText: '12 hours ago',
      actionType: 'review',
      type: 'GhostVerification',
    },
    {
      id: generateId(),
      caseSummary: 'Approve refund request for Mission #289',
      priority: 'low',
      createdAt: new Date(now.getTime() - 3 * 60 * 60 * 1000),
      createdAtText: '3 hours ago',
      updatedAt: new Date(now.getTime() - 3 * 60 * 60 * 1000),
      updatedAtText: '3 hours ago',
      actionType: 'approve',
      type: 'Dispute',
    },
    {
      id: generateId(),
      caseSummary: 'Review dispute resolution for Mission #156',
      priority: 'high',
      createdAt: new Date(now.getTime() - 6 * 60 * 60 * 1000),
      createdAtText: '6 hours ago',
      updatedAt: new Date(now.getTime() - 2 * 60 * 60 * 1000),
      updatedAtText: '2 hours ago',
      actionType: 'review',
      type: 'Dispute',
    },
  ];

  // Duplicate actions to create enough data for pagination testing
  const duplicatedActions: PendingAction[] = [];
  for (let i = 0; i < 4; i++) {
    actions.forEach(action => {
      duplicatedActions.push({
        ...action,
        id: generateId(),
      });
    });
  }

  return duplicatedActions;
};

export const mockPendingActions: PendingAction[] = generateMockPendingActions();

// Mock dashboard stats (KPIs)
export const mockDashboardStats: DashboardKPI[] = [
  {
    title: 'Active Missions',
    value: '1,240',
    change: '+5.2%',
    trend: 'up',
  },
  {
    title: 'New Missions Today',
    value: '52',
    change: '+10%',
    trend: 'up',
  },
  {
    title: 'Users Online',
    value: '88',
    change: '-1.5%',
    trend: 'down',
  },
];
